import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" $ ")

interface IProps {
    value: string | number;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    value: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_AppNumberFormat = _resolveComponent("AppNumberFormat")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_AppNumberFormat, {
      value: __props.value,
      format: "0.00"
    }, null, 8, ["value"])
  ], 64))
}
}

})